import React from 'react';

interface BlogProseProps {
  html: string;
  className?: string;
}

export function BlogProse({ html, className }: BlogProseProps) {
  return (
    <div
      className={`blog-prose ${className || ''}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
